import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { 
  X, 
  Plus,
  PenTool
} from 'lucide-react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const QuickAddDocModal = ({ isOpen, onClose, onSubmit }) => {
  const [docName, setDocName] = useState('');
  const [docDescription, setDocDescription] = useState('');

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setDocName('');
      setDocDescription('');
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (docName) {
      onSubmit(docName, docDescription);
      onClose();
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col  border-slate-100">
        
        {/* HEADER */}
        <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-gray-50/50">
          <div>
            <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
              <PenTool className="h-5 w-5 text-blue-600" />
              Add New Document
            </h3>
            <p className="text-xs text-slate-500 mt-2 ml-2">
              Define the document requirements
            </p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400 hover:text-slate-600 transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* CONTENT */}
        <div className="p-6 space-y-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Document Name <span className="text-red-500">*</span></label>
              <input 
                type="text" 
                className="w-full px-4 py-2.5 rounded-xl  border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all text-sm"
                placeholder="e.g. Passport Biodata Page"
                value={docName}
                onChange={(e) => setDocName(e.target.value)}
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Requirements / Description</label>
              <textarea 
                className="w-full px-4 py-2.5 rounded-xl  border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all text-sm min-h-[100px] resize-none"
                placeholder="Provide specific instructions (optional)..."
                value={docDescription}
                onChange={(e) => setDocDescription(e.target.value)}
              />
            </div>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200/50 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmit}
            disabled={!docName.trim()}
            className="px-6 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-lg hover:shadow-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed transform active:scale-95 flex items-center gap-2"
          >
            <Plus className="h-4 w-4" />
            Add Document
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default QuickAddDocModal;

